// 端口配置文件
const port = 80;
const BASEURL = 'https://admin.uzhikang.com/apiylxb';
const BASEURLIMG = 'https://adminswbd.obcin.com/wapimg/';

const API_LIST = {
	// 侧边栏数据
	sidebar: BASEURL + '/Index/sidebar',
	// 首页数据
	index: BASEURL + '/Index/index',
	// 上方分类栏
	nav: BASEURL + '/Index/nav',
	// 初始化列表
	list: BASEURL + '/Index/list',
	// 切换
	cateListData: BASEURL + '/Index/cateListData',
	// 详细
	content: BASEURL + '/Index/content',
	// 搜索
	select: BASEURL + '/Select/select',
	// 底部
	footer: BASEURL + '/Index/footer',
	// 
	banner_content: BASEURL + '/Index/banner_content',
	// 医院列表
	hospitalList: BASEURL + '/Index/hospitalList',
	// 药店信息
	drugList: BASEURL + '/Index/drugList',
	// 药品列表
	Druginfo_list: BASEURL + '/Druginfo/list',
	// 分类列表
	drug_list: BASEURL + '/Druginfo/drug_2_list',
	// 药品详情
	info: BASEURL + '/Druginfo/info',
}
module.exports = API_LIST;